(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Animates native <details>/<summary> height (Web Animations API),
    // mirroring reference-react/src/components/AccordionDetailsSection.tsx's
    // AnimatePresence height/opacity panel transition (0.25s ease-in-out).
    // Progressive enhancement only: no JS or no Element.animate support ->
    // <details> still opens/closes instantly and fully accessibly, native
    // markup and semantics are never altered.
    var DURATION = 250;

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function enhance(details) {
      if (details.dataset.accordionEnhanced) return;
      details.dataset.accordionEnhanced = 'true';

      var summary = details.querySelector(':scope > .accordion-details__summary');
      var content = details.querySelector(':scope > .accordion-details__content');
      if (!summary || !content) return;

      details.classList.toggle('is-open', details.open);

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function onFinish(open) {
        details.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        details.style.height = '';
        details.style.overflow = '';
      }

      function shrink() {
        details.classList.remove('is-open');
        isClosing = true;
        var startHeight = details.offsetHeight + 'px';
        var endHeight = summary.offsetHeight + 'px';
        details.style.overflow = 'hidden';
        if (animation) animation.cancel();
        animation = details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: 'ease-in-out' });
        animation.onfinish = function () { onFinish(false); };
        animation.oncancel = function () { isClosing = false; };
      }

      function expand() {
        details.classList.add('is-open');
        details.style.overflow = 'hidden';
        var startHeight = details.offsetHeight + 'px';
        // Pin the closed height before flipping `open`, or the browser
        // renders at full height for a frame before the animation can
        // correct it.
        details.style.height = startHeight;
        details.open = true;
        window.requestAnimationFrame(function () {
          isExpanding = true;
          var endHeight = summary.offsetHeight + content.offsetHeight + 'px';
          if (animation) animation.cancel();
          animation = details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: 'ease-in-out' });
          animation.onfinish = function () { onFinish(true); };
          animation.oncancel = function () { isExpanding = false; };
        });
      }

      summary.addEventListener('click', function (event) {
        if (prefersReducedMotion() || !('animate' in details)) return;
        event.preventDefault();

        // Let expand()/shrink()'s own `if (animation) animation.cancel()`
        // interrupt whatever is running -- calling onFinish() here first
        // would null out `animation` before that cancel can reach it,
        // leaving the stale animation's onfinish to fire later and
        // reopen/reclose the accordion against the user's last click.
        if (isClosing || !details.open) {
          expand();
        } else if (isExpanding || details.open) {
          shrink();
        }
      });
    }

    function setup(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.accordion-details__item').forEach(enhance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setup(document);
      });
    } else {
      setup(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      setup(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function setupPolicyModal(root) {
      var scope = root || document;
      var modal = scope.querySelector('#policy-modal');
      var triggers = scope.querySelectorAll('[data-policy-trigger]');

      if (!modal || triggers.length === 0) return;

      var panel = modal.querySelector('.policy-modal__panel');
      var titleEl = modal.querySelector('#policy-modal-title');
      var bodyEl = modal.querySelector('#policy-modal-body');
      var closeBtn = modal.querySelector('#policy-modal-close-btn');
      var dismissEls = modal.querySelectorAll('[data-policy-modal-dismiss]');

      if (!panel || !titleEl || !bodyEl || !closeBtn) return;

      var lastTrigger = null;
      var keydownHandler = null;

      function closeModal() {
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';

        if (keydownHandler) {
          document.removeEventListener('keydown', keydownHandler);
          keydownHandler = null;
        }

        if (lastTrigger) {
          lastTrigger.focus();
          lastTrigger = null;
        }
      }

      function openModal(trigger) {
        var templateId = trigger.getAttribute('data-template');
        var template = templateId ? document.getElementById(templateId) : null;
        if (!template) return;

        lastTrigger = trigger;
        titleEl.textContent = template.getAttribute('data-policy-title') || '';
        bodyEl.innerHTML = '';
        bodyEl.appendChild(template.content.cloneNode(true));

        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();

        keydownHandler = function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key === 'Tab') {
            var focusables = panel.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (focusables.length === 0) return;

            var firstEl = focusables[0];
            var lastEl = focusables[focusables.length - 1];

            if (event.shiftKey && document.activeElement === firstEl) {
              event.preventDefault();
              lastEl.focus();
            } else if (!event.shiftKey && document.activeElement === lastEl) {
              event.preventDefault();
              firstEl.focus();
            }
          }
        };

        document.addEventListener('keydown', keydownHandler);
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          openModal(trigger);
        });
      });

      dismissEls.forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setupPolicyModal(document);
      });
    } else {
      setupPolicyModal(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      setupPolicyModal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function setupMobileNav(root) {
      var scope = root || document;
      var toggleBtn = scope.querySelector('#mobile-nav-toggle-btn');
      var menu = scope.querySelector('#mobile-nav-menu');
      var closeBtn = scope.querySelector('#close-mobile-nav-btn');
      var panel = menu ? menu.querySelector('.mobile-nav__panel') : null;
      var backdrop = menu ? menu.querySelector('.mobile-nav__backdrop') : null;
      var navLinks = menu ? menu.querySelectorAll('.mobile-nav__nav a') : [];

      if (!toggleBtn || !menu || !closeBtn || !panel) return;

      var focusTimer = null;
      var keydownHandler = null;
      var closeTimer = null;
      var openRAF = null;
      var CLOSE_TRANSITION_MS = 300;

      function prefersReducedMotion() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      }

      function closeMenu() {
        if (closeTimer !== null) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }

        if (openRAF !== null) {
          window.cancelAnimationFrame(openRAF);
          openRAF = null;
        }

        menu.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        closeTimer = window.setTimeout(function () {
          menu.setAttribute('hidden', '');
          closeTimer = null;
        }, prefersReducedMotion() ? 0 : CLOSE_TRANSITION_MS);

        if (focusTimer !== null) {
          window.clearTimeout(focusTimer);
          focusTimer = null;
        }

        if (keydownHandler) {
          document.removeEventListener('keydown', keydownHandler);
          keydownHandler = null;
        }
      }

      function openMenu() {
        if (menu.classList.contains('is-open')) return;

        if (closeTimer !== null) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }

        if (openRAF !== null) {
          window.cancelAnimationFrame(openRAF);
          openRAF = null;
        }

        menu.removeAttribute('hidden');
        // Force a reflow so the off-screen state paints before .is-open is
        // added, otherwise display:none -> visible and the transform change
        // land in the same style recalc and the transition never plays.
        void menu.offsetHeight;
        openRAF = window.requestAnimationFrame(function () {
          openRAF = null;
          menu.classList.add('is-open');
        });

        toggleBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        focusTimer = window.setTimeout(function () {
          closeBtn.focus();
        }, 50);

        keydownHandler = function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeMenu();
            toggleBtn.focus();
            return;
          }

          if (event.key === 'Tab') {
            var focusables = panel.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (focusables.length === 0) return;

            var firstEl = focusables[0];
            var lastEl = focusables[focusables.length - 1];

            if (event.shiftKey && document.activeElement === firstEl) {
              event.preventDefault();
              lastEl.focus();
            } else if (!event.shiftKey && document.activeElement === lastEl) {
              event.preventDefault();
              firstEl.focus();
            }
          }
        };

        document.addEventListener('keydown', keydownHandler);
      }

      toggleBtn.addEventListener('click', openMenu);

      closeBtn.addEventListener('click', function () {
        closeMenu();
        toggleBtn.focus();
      });

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeMenu();
          toggleBtn.focus();
        });
      }

      navLinks.forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setupMobileNav(document);
      });
    } else {
      setupMobileNav(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      setupMobileNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CremapuraHeroParallax) return;

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    var SCROLL_RANGE = 600;
    var ticking = false;
    var particles = null;

    function applyParallax() {
      ticking = false;
      if (!particles || particles.length === 0) return;

      var t = Math.min(Math.max(window.scrollY || 0, 0), SCROLL_RANGE) / SCROLL_RANGE;

      particles.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
        el.style.setProperty('--parallax-y', (-60 * speed * t) + 'px');
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(applyParallax);
    }

    function setup() {
      if (prefersReducedMotion()) return;

      particles = document.querySelectorAll('.hero-particle[data-parallax-speed]');
      if (particles.length === 0) return;

      applyParallax();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }

    window.CremapuraHeroParallax = { applyParallax: applyParallax };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var scope = root && root.querySelector ? root : document;
      var heading = scope.querySelector('.statement-banner__heading');
      if (!heading || !window.IntersectionObserver) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      heading.classList.add('will-reveal');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            heading.classList.add('is-revealed');
            observer.unobserve(heading);
          }
        });
      });
      observer.observe(heading);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setup(document);
      });
    } else {
      setup(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      setup(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
